'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selectVenueScheduleDate = exports.selectVenueId = exports.selectScheduleId = exports.selectDynamicTagsInfo = exports.selectClassId = exports.setVenueScheduleExpanded = exports.setVenueScheduleDate = exports.setVenueId = exports.setTagSerpLinks = exports.setScheduleId = exports.setMovementSerpLinks = exports.setLocationSerpLink = exports.setDynamicTagsInfo = exports.setClassId = exports.setActivitySerpLinks = exports.SET_VENUE_SCHEDULE_DATE = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.default = reducer;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET_CLASS_ID = 'classpass/venue-detail/SET_CLASS_ID';
var SET_CLASS_MOVEMENT_SERP_LINKS = 'classpass/venue-detail/SET_CLASS_MOVEMENT_SERP_LINKS';
var SET_DYNAMIC_TAGS_INFO = 'classpass/venue-detail/SET_DYNAMIC_TAGS_INFO';
var SET_SCHEDULE_ID = 'classpass/venue-detail/SET_SCHEDULE_ID';
var SET_STUDIO_ACTIVITY_SERP_LINKS = 'classpass/venue-detail/SET_STUDIO_ACTIVITY_SERP_LINKS';
var SET_STUDIO_LOCATION_SERP_LINK = 'classpass/venue-detail/SET_STUDIO_LOCATION_SERP_LINK';
var SET_STUDIO_TAG_SERP_LINKS = 'classpass/venue-detail/SET_STUDIO_TAG_SERP_LINKS';
var SET_VENUE_ID = 'classpass/venue-detail/SET_VENUE_ID';
var SET_VENUE_SCHEDULE_EXPANDED = 'classpass/venue-detail/SET_VENUE_SCHEDULE_EXPANDED';
var SET_VENUE_SCHEDULE_DATE = exports.SET_VENUE_SCHEDULE_DATE = 'classpass/venue-detail/SET_VENUE_SCHEDULE_DATE';

var initialState = {
  activitySerpLinks: [],
  classId: 0,
  dynamicTagsInfo: {},
  locationSerpLink: null,
  movementSerpLinks: [],
  msaId: 0,
  scheduleExpanded: false,
  scheduleId: 0,
  tagSerpLinks: [],
  venueId: 0,
  venueScheduleDate: ''
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET_CLASS_ID:
    case SET_CLASS_MOVEMENT_SERP_LINKS:
    case SET_DYNAMIC_TAGS_INFO:
    case SET_SCHEDULE_ID:
    case SET_STUDIO_ACTIVITY_SERP_LINKS:
    case SET_STUDIO_LOCATION_SERP_LINK:
    case SET_STUDIO_TAG_SERP_LINKS:
    case SET_VENUE_ID:
    case SET_VENUE_SCHEDULE_DATE:
    case SET_VENUE_SCHEDULE_EXPANDED:
      return (0, _extends4.default)({}, state, (0, _defineProperty3.default)({}, action.data.key, action.data.value));
    default:
      return state;
  }
}

var setActivitySerpLinks = exports.setActivitySerpLinks = function setActivitySerpLinks(value) {
  return { type: SET_STUDIO_ACTIVITY_SERP_LINKS, data: { key: 'activitySerpLinks', value: value } };
};
var setClassId = exports.setClassId = function setClassId(classId) {
  return { type: SET_CLASS_ID, data: { key: 'classId', value: parseInt(classId, 10) } };
};
var setDynamicTagsInfo = exports.setDynamicTagsInfo = function setDynamicTagsInfo(dynamicTagsInfo) {
  return { type: SET_DYNAMIC_TAGS_INFO, data: { key: 'dynamicTagsInfo', value: dynamicTagsInfo } };
};
var setLocationSerpLink = exports.setLocationSerpLink = function setLocationSerpLink(value) {
  return { type: SET_STUDIO_LOCATION_SERP_LINK, data: { key: 'locationSerpLink', value: value } };
};
var setMovementSerpLinks = exports.setMovementSerpLinks = function setMovementSerpLinks(value) {
  return { type: SET_CLASS_MOVEMENT_SERP_LINKS, data: { key: 'movementSerpLinks', value: value } };
};
var setScheduleId = exports.setScheduleId = function setScheduleId(scheduleId) {
  return { type: SET_SCHEDULE_ID, data: { key: 'scheduleId', value: parseInt(scheduleId, 10) } };
};
var setTagSerpLinks = exports.setTagSerpLinks = function setTagSerpLinks(value) {
  return { type: SET_STUDIO_TAG_SERP_LINKS, data: { key: 'tagSerpLinks', value: value } };
};
var setVenueId = exports.setVenueId = function setVenueId(venueId) {
  return { type: SET_VENUE_ID, data: { key: 'venueId', value: parseInt(venueId, 10) } };
};
var setVenueScheduleDate = exports.setVenueScheduleDate = function setVenueScheduleDate(value) {
  return { type: SET_VENUE_SCHEDULE_DATE, data: { key: 'venueScheduleDate', value: value } };
};
var setVenueScheduleExpanded = exports.setVenueScheduleExpanded = function setVenueScheduleExpanded(value) {
  return { type: SET_VENUE_SCHEDULE_EXPANDED, data: { key: 'scheduleExpanded', value: value } };
};

var selectClassId = exports.selectClassId = function selectClassId(state) {
  return state.features.venueDetail.classId;
};
var selectDynamicTagsInfo = exports.selectDynamicTagsInfo = function selectDynamicTagsInfo(state) {
  return state.features.venueDetail.dynamicTagsInfo;
};
var selectScheduleId = exports.selectScheduleId = function selectScheduleId(state) {
  return state.features.venueDetail.scheduleId;
};
var selectVenueId = exports.selectVenueId = function selectVenueId(state) {
  return state.features.venueDetail.venueId;
};
var selectVenueScheduleDate = exports.selectVenueScheduleDate = function selectVenueScheduleDate(state) {
  return state.features.venueDetail.venueScheduleDate;
};